import {
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_FAILURE,
    GET_TRANSACTION_LIST_REQUEST,
    GET_TRANSACTION_LIST_SUCCESS,
    GET_TRANSACTION_LIST_FAILURE,
} from '../constant/actionTypes'

export const getUser = payload => ({
    type: GET_USER_REQUEST,
    payload
})

export const getUserSuccess = payload => ({
    type: GET_USER_SUCCESS,
    payload
})

export const getUserFailure = payload => ({
    type: GET_USER_FAILURE,
    payload
})

export const getTransactionList = payload => ({
    type: GET_TRANSACTION_LIST_REQUEST,
    payload
})


export const getTransactionListSuccess = payload => ({
    type: GET_TRANSACTION_LIST_SUCCESS,
    payload
})


export const getTransactionListFailure = payload => ({
    type: GET_TRANSACTION_LIST_FAILURE,
    payload
})